import React, { useCallback } from "react";
import styled from "styled-components";
import MotifButton from "@ey/motif-react-wrapper/Button";
import { labels } from "../../../util/utils";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";

export interface BottomNavigationProps {
  onNext?: () => void;
  onBack?: () => void;
  nextLabel?: string;
  hideNext?: boolean;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ onNext, onBack, nextLabel, hideNext }) => {
  return (
    <StyledBottomNavigation>
      <MotifButton onClick={onBack} variant="secondary" className="back-button">
        <MotifIcon src={IconoirArrowLeft} size="20" />
      </MotifButton>
      {!hideNext && (
        <MotifButton onClick={onNext} variant="primary-alt">
          {nextLabel || labels.Continue}
        </MotifButton>
      )}
    </StyledBottomNavigation>
  );
};

export default BottomNavigation;

const StyledBottomNavigation = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-large) var(--spacing-xx-large);
  border-top: var(--px-1) solid var(--neutrals-100);

  .back-button {
    margin-right: var(--px-10);
  }
`;
